import HowToVote from '@mui/icons-material/HowToVote';
import SegredoJustica from '@mui/icons-material/Lock';
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogTitle,
    Divider,
    Paper,
    Tooltip,
    Typography
} from '@mui/material';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Fragment } from 'react';
import Configuracao from '../../util/Configuracao';
import ReactComponent from '../ReactComponent';
import IconesMagistradosProcesso from './IconesMagistradosProcesso';
import SituacaoJulgamentoProcessoBusiness from '@/dominio/SituacaoJulgamentoProcessoBusiness';

class LiberarDispositivoVoto extends ReactComponent {
    dialogOpen = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            dialogOpen: observable,
            listaProcessosSelecionados: computed,
            sessao: computed,
            processosParaLiberarDispositivo: computed,
            todosSelecionados: computed,
            inicializaEstadoLiberacaoDispositivoVoto: action,
            handleClickIcone: action,
            handleCloseDialog: action,
            handleSelecionarProcesso: action,
            toggleSelecionarTodos: action
        });
    }

    get listaProcessosSelecionados() {
        return this.processosParaLiberarDispositivo.filter((registro) => registro.checkedLiberarDispositivoVoto);
    }

    componentDidMount() {
        this.inicializaEstadoLiberacaoDispositivoVoto();
    }

    get sessao() {
        return this.sessaoStore.sessaoSelecionada;
    }

    get processosParaLiberarDispositivo() {
        let processosApreciados = this.salaSessaoStore.filtros.filtroOrigem.filtrar(
            this.salaSessaoStore.processosApreciados,
            Configuracao.ORIGEM_PJE
        );

        return processosApreciados.filter(
            (registro) =>
                !registro.dispositivoLiberado &&
                registro.resultadoJulgamento &&
                SituacaoJulgamentoProcessoBusiness.isProcessoJulgado(registro.resultadoJulgamento)
        );
    }

    get todosSelecionados() {
        return (
            this.listaProcessosSelecionados.length > 0 &&
            this.listaProcessosSelecionados.length === this.processosParaLiberarDispositivo.length
        );
    }

    inicializaEstadoLiberacaoDispositivoVoto = () => {
        this.processosParaLiberarDispositivo.forEach((registro) => {
            runInAction(() => (registro.checkedLiberarDispositivoVoto = true));
        });
    };

    handleClickIcone = () => {
        this.dialogOpen = true;
    };

    handleCloseDialog = () => {
        this.dialogOpen = false;
    };

    handleSelecionarProcesso = (registro) => {
        registro.checkedLiberarDispositivoVoto = !registro.checkedLiberarDispositivoVoto;
    };

    toggleSelecionarTodos = () => {
        let checkedLiberarDispositivoVoto = !this.todosSelecionados;

        this.processosParaLiberarDispositivo.map((registro) => {
            runInAction(() => (registro.checkedLiberarDispositivoVoto = checkedLiberarDispositivoVoto));
            return registro;
        });
    };

    handleClickBotaoLiberar = async () => {
        let numerosCompletos = this.listaProcessosSelecionados.map((registro) => {
            return registro.processo.numeroCompleto;
        });
        let retorno = await this.sessaoService.liberarDispositivosVoto(
            this.listaProcessosSelecionados[0].sessaoId,
            numerosCompletos
        );
        this.handleCloseDialog();
        this.abrirMensagemAposLiberarLote(retorno);
    };

    abrirMensagemAposLiberarLote(retorno) {
        let processosSucesso = [];
        let processosErro = [];

        for (let retornoProcesso of retorno) {
            if (retornoProcesso.tipo === 'SUCESSO') {
                processosSucesso.push(retornoProcesso.elemento);
            } else {
                processosErro.push(retornoProcesso.elemento);
            }
        }

        let mensagem = processosSucesso.length + ' processo(s) com dispositivo(s) liberado(s) com sucesso.';

        if (processosErro.length > 0) {
            mensagem += ' Ocorreu erro ao liberar dispositivo dos seguintes processo(s): ' + processosErro.join(', ');
            this.salaSessaoStore.recarregarListaProcessos();
            this.mensagemStore.abrirMensagemErro(mensagem);
        } else {
            this.mensagemStore.abrirMensagemSucesso(mensagem);
        }
    }

    render() {
        if (
            !this.isComponenteHabilitado('LiberarDispositivoVoto') ||
            this.parametroStore.usaCertidao() ||
            !this.salaSessaoStore.existeSessaoPJe
        ) {
            return null;
        }

        return (
            <>
                <div
                    style={{ marginRight: '10px' }}
                    className="corBotao"
                >
                    <Tooltip
                        title={'Liberar dispositivo de voto do PJe em lote'}
                        placement="top-start"
                    >
                        <HowToVote
                            style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                            onClick={this.handleClickIcone}
                        />
                    </Tooltip>
                </div>
                {this.dialogOpen && (
                    <Dialog
                        fullWidth
                        maxWidth="md"
                        onClose={this.handleCloseDialog}
                        open={this.dialogOpen}
                    >
                        <DialogTitle style={{ padding: '24px 24px 10px' }}>
                            Liberar dispositivo de voto do PJe em lote
                        </DialogTitle>
                        <Paper
                            elevation={10}
                            style={{ margin: '20px', overflowY: 'auto', minHeight: '250px', maxHeight: '500px' }}
                        >
                            {this.processosParaLiberarDispositivo && this.processosParaLiberarDispositivo.length > 0 ? (
                                <Fragment>
                                    <div style={{ display: 'flex', fontWeight: 'bold' }}>
                                        <Tooltip title="Selecionar/Deselecionar todos">
                                            <Checkbox
                                                checked={this.todosSelecionados}
                                                onChange={this.toggleSelecionarTodos}
                                            />
                                        </Tooltip>
                                        <span style={{ marginLeft: '0.5em', marginTop: '1em' }}>Selecionar todos</span>
                                    </div>
                                    <Divider style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }} />
                                    {this.processosParaLiberarDispositivo.map((registro) => (
                                        <div
                                            key={this.nextKey}
                                            style={{ display: 'flex' }}
                                        >
                                            <Checkbox
                                                checked={registro.checkedLiberarDispositivoVoto}
                                                onChange={this.handleSelecionarProcesso.bind(this, registro)}
                                            />
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        fontSize: '11pt',
                                                        minWidth: '400px',
                                                        color: registro.segredoJustica ? 'red' : '',
                                                        margin: '5px 10px'
                                                    }}
                                                >
                                                    {registro.processo.numeroCompleto}
                                                    {registro.segredoJustica ? (
                                                        <SegredoJustica
                                                            style={{
                                                                height: '16px',
                                                                width: '16px',
                                                                marginLeft: '4px',
                                                                marginBottom: '4px'
                                                            }}
                                                        />
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                                <IconesMagistradosProcesso registro={registro} />
                                            </div>
                                            <Divider style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }} />
                                        </div>
                                    ))}
                                </Fragment>
                            ) : (
                                <Typography
                                    variant="body1"
                                    style={{ margin: '20px' }}
                                >
                                    {'Não há processos com dispositivo de voto pendente de liberação'}
                                </Typography>
                            )}
                        </Paper>
                        <DialogActions>
                            <Button
                                onClick={this.handleCloseDialog}
                                color="secondary"
                            >
                                Cancelar
                            </Button>
                            <Button
                                onClick={this.handleClickBotaoLiberar}
                                color="primary"
                                disabled={
                                    !this.listaProcessosSelecionados || this.listaProcessosSelecionados.length === 0
                                }
                            >
                                Liberar
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}
            </>
        );
    }
}

export default inject('stores')(observer(LiberarDispositivoVoto));
